import L from 'leaflet';
import React, { Ref, useEffect, useRef, useState } from 'react';
import dayjs, { Dayjs } from 'dayjs';
import SlowBookOverlayWorker from 'worker-loader!../slowOverlay.worker';
import { v4 as uuid } from 'uuid';
import { ImageOverlay, Marker, Polygon } from 'react-leaflet';
import { capitalize, groupBy, orderBy, uniq } from 'lodash';
import { Card, Descriptions, Space, Spin, message } from 'antd';
import { Capa, Container, Content, ContentPontos, Page, PdfPrint, ResumoNutrientes, SubCapa, SubCapaWhite, Sumario, TrReverse, Warning } from './styles';

//APP
import { useLogic } from '../useLogic'
import { OsItensTypes } from '../../../../services/Laboratorio';
import { PropriedadeItens } from '../../../../services/Propriedades';
import { ItensElementosTypes } from '../../../../services/Elementos';
import { ConsultoriaItensTypes } from '../../../../services/Cliente';
import { ItensMapaFertilidadeTypes } from '../../../../services/Laboratorio/osResultado';
import { ItensConfigConsultoriaTypes, getConfigBook } from '../../../../services/configBook';
import { decodeHtml, geraOverlayView, iconDiv, middleIndex, tryError } from '../../../../services/Afins';

//STYLES

//COMPONENTS
import MapLeaflet from '../../../MapLeaflet';
import RodapeTtivvos from '../../../RodapeTtivos';
import BackToTopButton from '../../../BackTop';
import TabelaFertilidade from './components/tabelaFertilidade';

interface Props {
  idPrint?: string
  typeKricagem: boolean
  defaultBounds: L.LatLngBounds
  isLoading?: (loading: boolean) => void
  exibeTerreno?: boolean
  idScroll?: string
  dataColeta: Dayjs | string
  dataFertilidade: { [key: string]: ItensMapaFertilidadeTypes[] }
  talhao: OsItensTypes['talhao_kml']
  propriedade: PropriedadeItens
  talhaoNome: string
  areaTalhao?: string
  elementosData: ItensElementosTypes[]
  rangeZoom?: number
  onRangeZoom?: (zoom: number) => void
  consultoria: ConsultoriaItensTypes
  nameCliente: string
  openBook?: boolean
  refPrint?: Ref<HTMLDivElement>
  cod_prescricoes: Set<number>
  cods_q_devem_ser_reverso?: number[];
  setNome_cliente_painel?: React.Dispatch<React.SetStateAction<string>>;
  nome_calcario_propriedade?: any;
  qualidade_definicao_book?: number;
  sempre_quebrar_sumario?: boolean;
}

interface PropKrikagem {
  bounds: L.LatLngBounds
  circle: L.LatLngTuple[]
  dataProfundidade: ItensMapaFertilidadeTypes[]
  krigagem: {
    url: string
    colors: any[]
    descriptionElemento: string
    ordem: number
    bounds: {
      east: number
      north: number
      south: number
      west: number
    },
    valor_interpretado: {minimo: number, media: number, maximo: number}
  }[]
}

const DrawerPrintMapaFertilidade: React.FC<Props> = (props) => {
  const {
    idPrint,
    refPrint,
    dataFertilidade,
    talhao = { coordenadas: [] },
    talhaoNome,
    propriedade,
    typeKricagem,
    defaultBounds,
    dataColeta,
    elementosData,
    isLoading,
    idScroll = 'divScroll',
    rangeZoom,
    areaTalhao,
    nameCliente,
    consultoria,
    onRangeZoom,
    exibeTerreno,
    openBook,
    cod_prescricoes,
    cods_q_devem_ser_reverso,
    setNome_cliente_painel,
    nome_calcario_propriedade,
    qualidade_definicao_book,
    sempre_quebrar_sumario
  } = props

  const { generateColors } = useLogic();

  // console.log("OSS: ", nome_calcario_propriedade);

  const [polygon, setPolygon] = useState<L.LatLngExpression[]>([])
  const [loading, setLoading] = useState(false)

  const [dataConfigMapaFertilidade, setDataConfigMapaFertilidade] =
    useState<ItensConfigConsultoriaTypes>({} as ItensConfigConsultoriaTypes)

  const [dataElementos, setDataElementos] = useState<{ [key: string]: ItensMapaFertilidadeTypes[] }[]>([])
  const [dataKricagem, setDataKrikagem] = useState<PropKrikagem[]>([]);

  const [cores_filtradas, setCores_filtradas] = useState([]);

  const refPdfPrint = useRef<HTMLDivElement>()
  const refSumario = useRef<HTMLDivElement>()

  const mapL = useRef<L.Map[]>([]);

  //LOCAL
  const tipoAcesso = localStorage.getItem('tipo-acesso');
  const nomeBookApp = JSON.parse(localStorage.getItem('bookApp'));
  const nomeClienteLocal = localStorage.getItem('nome-cliente')

  //STATES
  const [logo_cliente, setLogo_cliente] = useState('');
  const [nome_cliente, setNome_cliente] = useState('');

  const filtrarDadosLocal = () => {
    if (nomeBookApp == 1) {
      setLogo_cliente(localStorage.getItem('logo'));
      setNome_cliente(localStorage.getItem('nome-cliente'));
      setNome_cliente_painel(localStorage.getItem('nome-cliente'));
    } else {
      const cod =
        tipoAcesso === 'conta'
          ? JSON.parse(localStorage.getItem('conta'))
          : JSON.parse(localStorage.getItem('cod-cliente'))

      const licenciadoPara = tipoAcesso === 'cliente' ? nomeClienteLocal : consultoria.linha1;
      setNome_cliente(licenciadoPara);
      setNome_cliente_painel(licenciadoPara);
      const dadosLocal = JSON?.parse?.(localStorage.getItem('Itens'))?.[0]
      const acessoCliente = dadosLocal?.['acessoConta']
      const clientes = tipoAcesso === 'conta' ? acessoCliente['contas'] : acessoCliente['clientes']
      const dadosLogoLocal = clientes.find((codId) => codId.cod === cod)
      if (dadosLogoLocal) {
        const logos = dadosLogoLocal?.['logo']
        setLogo_cliente(logos)
      }
    }
  }
  

  const listConfigMapaFertilidade = async () => {
    const resp = await getConfigBook()

    setDataConfigMapaFertilidade(resp.data.itens[0])
  }

  const overLayGera = async ({ grid, colors, lats, longs }) => {
    let overlay: { url: string; bounds: any; key: any; colors: any }
    if (colors.length > 1) {
      overlay = await geraOverlayView(grid, lats, longs, colors)
    } else {
      overlay = { key: null, url: null, colors, bounds: null }
    }

    return overlay
  }

  function AgruparElementosPrecricao(dados_prescricao) {
    // console.log("dados_prescricao: ", dados_prescricao);
    let result = dados_prescricao.reduce((acc, curr) => {
      // const existingEntry = acc.find(entry => entry.cod_elemento === curr.cod_elemento && entry.label === `${curr.elemento} ${curr.profundidade}`);
      // if (existingEntry) {
      //   return acc;
      // }
      // if (curr.cod_elemento=== 30 && curr.profundidade === '20-40') {
      //   return acc;
      // }
      const newEntry = {
        classificacao: curr.classificacao,
        cod_elemento: curr.cod_elemento,
        cod_elemento_pedido: curr.cod_elemento_pedido,
        cod_profundidade: curr.cod_profundidade,
        cod_propriedade: curr.cod_propriedade,
        cod_safra_conta: curr.cod_safra_conta,
        create_time: curr.create_time,
        create_user: curr.create_user,
        delete_time: curr.delete_time,
        delete_user: curr.delete_user,
        elemento: curr.elemento,
        elemento_descricao: curr.elemento_descricao==='Calcário' ? `${curr.elemento_descricao} ${curr.profundidade}` : `${curr.elemento_descricao}`,
        cod_elemento_descricao: curr.cod_elemento === 30 ? `${curr.cod_elemento} | ${curr.profundidade}` : curr.cod_elemento ,
        latitude: curr.latitude,
        limite_maximo: curr.limite_maximo,
        limite_minimo: curr.limite_minimo,
        longitude: curr.longitude,
        maximo: curr.maximo,
        media: curr.media,
        minimo: curr.minimo,
        observacao: curr.observacao,
        ordem: curr.ordem,
        ponto: curr.ponto,
        profundidade: curr.profundidade,
        qualidade: curr.qualidade,
        unidade: curr.unidade,
        update_time: curr.update_time,
        update_user: curr.update_user,
        uso_mapa: curr.uso_mapa,
        valor: curr.valor,
        valor_distribuido:  curr.valor_distribuido,
        valor_interpretado: cod_prescricoes.has(curr.cod_elemento) ? curr.valor_distribuido : curr.valor_interpretado
      };
      return [...acc, newEntry];
    }, []);

    return result
  }

  useEffect(() => {
    let dados = []
    // console.log("dataFertilidade: ", dataFertilidade);
    Object.entries(dataFertilidade).map(([key, value]) => {
      
      const filter = value.filter((rec) =>
        typeKricagem ? (rec.valor_interpretado !== null || cod_prescricoes.has(rec.cod_elemento)) : rec.valor_distribuido !== null
      )
      if (filter.length > 0) {
        const or = orderBy(filter, (or) => {
          return Number(or.ordem)
        })
        // console.log("OR: ", (or));
        dados = [...dados, groupBy(AgruparElementosPrecricao(or), 'cod_elemento_descricao')]
        // console.log("DADOS: ", dados);
        // dados = [...dados, groupBy(or, 'cod_elemento')]
      }
    })

    // console.log('dataFertilidade: ', dataFertilidade);
    // console.log('ENTRIES: ', Object.entries(dataFertilidade));
    // console.log('dados: ', dados);

    function ajustarArraysNaEstrutura(objeto) {
      function ajustarArray(array) {
        if (array.length === 1) {
          while (array.length < 3) {
            array.push(array[0])
          }
        }
        return array
      }

      function percorrer(obj) {
        for (const chave in obj) {
          if (Array.isArray(obj[chave])) {
            obj[chave] = ajustarArray(obj[chave])
          } else if (typeof obj[chave] === 'object') {
            percorrer(obj[chave])
          }
        }
      }

      percorrer(objeto)

      return objeto
    }

    ajustarArraysNaEstrutura(dados)
    // console.log("1 - dataElementos: ", dados);
    setDataElementos(dados)

    // setDataElementos(newArray)

    // setDataElementos(dados)
    if (Object.keys((rec) => rec).length === 0) {
      setDataKrikagem([])
    }
  }, [dataFertilidade]);

  function definicaoDaKrigagem(): number {
    if (Number(areaTalhao) < 70) {
      return 0.00003
    }
    if (Number(areaTalhao) < 100) {
      return 0.00004
    }
    if (Number(areaTalhao) < 200) {
      return 0.00005
    }
    if (Number(areaTalhao) < 300) {
      return 0.0001
    }
    if (Number(areaTalhao) < 400) {
      return 0.0002
    }
    if (Number(areaTalhao) > 400) {
      return 0.0003
    }
  }

  useEffect(() => {
    if (dataElementos.length > 0) {
      const fetchData = async () => {
        setLoading(true)
        isLoading?.(true)
        let dataUrls: {
          bounds: any
          circle: any
          dataProfundidade: any
          qualidade_definicao_book: number
          krigagem: {
            coord: any[]
            points: any[]
            colors: any[]
            descriptionElemento: string
            ordem: number,
            valor_interpretado:any
          }[]
        }[] = []

        for (let i = 0; i < dataElementos.length; i++) {
          const data = dataElementos[i]
          // console.log("dataElementos: ", dataElementos);
          const index = Object.keys(data)[0]
          const circle = data[index]

          const latLng: L.LatLngTuple[] = circle.map((rec) => {
            return [Number(rec.latitude), Number(rec.longitude)]
          })

          const polygon = new L.Polygon(latLng, {})

          const bounds = polygon.getBounds()
          // console.log("DATA INIT: ", (data));
          // console.log("DATA entri: ", Object.entries(data));
          // let lista_kri = Object.entries(data).map(([key, value])=> {
          //     return {
          //       cod_elemento: Number?.(key),
          //       teste: value.map((rec) =>
          //         rec.valor_interpretado
          //     )
          //   }
          // });

          dataUrls = [
            ...dataUrls,
            {
              bounds,
              circle: latLng,
              dataProfundidade: circle,
              // qualidade_definicao_book: definicaoDaKrigagem(),
              qualidade_definicao_book: qualidade_definicao_book,
              krigagem: await Promise.all(
                Object.entries(data).map(async ([key, value]) => {
                  const reverse = cods_q_devem_ser_reverso.indexOf(Number(key?.split('|')?.[0])) > -1
                    // Number(key) === 7 || Number(key) === 18 || Number(key) === 28 || Number(key) === 30 ? true : false
                  const colors = uniq(
                    generateColors(
                      value.map((rec) =>
                        Number(typeKricagem ? ( cod_prescricoes.has(rec.cod_elemento) ? rec.valor_distribuido : rec.valor_interpretado) : rec.valor_distribuido)
                      ),
                      (cod_prescricoes.has(Number(key)) ? false : (key === '30 | 00-30' ? false : typeKricagem) ),
                      !reverse
                    )
                  )
                  const uniqArrayColors = colors.filter((value, index, self) => {
                    return self.indexOf(value) === index
                  })
                  setCores_filtradas(uniqArrayColors)
                  const lastColor = colors[colors.length - 1]

                  colors.push(lastColor)

                  const pontos = value.map((rec) => {
                    return {
                      lat: Number(rec.latitude),
                      lng: Number(rec.longitude),
                      ponto: String(rec.ponto),
                      valor: rec.valor,
                      valorDistribuido: typeKricagem
                        ? ( cod_prescricoes.has(rec.cod_elemento) ? rec.valor_distribuido : rec.valor_interpretado)
                        : rec.valor_distribuido,
                    }
                  })
                  const coord = talhao?.coordenadas.map((rec) => {
                    return [Number(rec.longitude), Number(rec.latitude)]
                  })

                  const poly: L.LatLngExpression[] = talhao?.coordenadas.map((rec) => {
                    return { lat: Number(rec.latitude), lng: Number(rec.longitude) }
                  })

                  setPolygon(poly)

                  const valuesDis = value.map((rec) =>
                    Number(typeKricagem ? ( cod_prescricoes.has(rec.cod_elemento) ? rec.valor_distribuido : rec.valor_interpretado) : rec.valor_distribuido)
                  )

                  const points = [
                    {
                      t: valuesDis,
                      x: pontos.map((rec) => rec.lng),
                      y: pontos.map((rec) => rec.lat),
                    },
                  ]

                  // console.log("VALUE: ", value?.map((item)=> { return {valor_interpretado: item.valor_interpretado, descri_elemento: item.elemento_descricao}}));

                  const krig = {
                    coord,
                    points,
                    colors,
                    descriptionElemento: value[0].elemento_descricao,
                    ordem: Number(value[0].ordem),
                    valor_interpretado: value?.map((item)=> { return item.valor_interpretado})
                  }

                  return krig
                })
              ),
            },
          ]
        }


        const webWorkerBook = new SlowBookOverlayWorker();

        webWorkerBook.onmessage = async (e) => {
          const data_worker: {
            bounds: L.LatLngBounds
            circle: L.LatLngTuple[]
            dataProfundidade: ItensMapaFertilidadeTypes[]
            krigagem: { grid; lats; longs; colors; descriptionElemento; ordem, valor_interpretado, teste }[]
          }[] = await e.data
          // console.log("INICIO OVER: ", e);
          try {
            const overlayView = data_worker?.map?.(async (rec) => {
              // console.log("OVERLAY: ", (rec?.krigagem));
              const response = (rec?.krigagem ?? [] ).map(async (item) => {
                const overlay = await overLayGera({ ...item })
                return {
                  url: overlay?.url,
                  colors: uniq(overlay.colors),
                  descriptionElemento: item.descriptionElemento,
                  ordem: Number(item.ordem),
                  bounds: overlay.bounds, // falta esse
                  valor_interpretado: item.valor_interpretado
                }
              })
              const resolve = await Promise.all(response)
              return {
                bounds: rec.bounds,
                circle: rec.circle,
                dataProfundidade: rec.dataProfundidade,
                krigagem: orderBy(resolve, 'ordem')
              }
            })

            const resolve = await Promise.all(overlayView)

            setDataKrikagem(resolve)

            isLoading?.(false)
            setLoading(false)
            message.destroy()
            webWorkerBook.terminate()
          } catch (error) {
            webWorkerBook.terminate()
            setLoading(false)
            isLoading?.(false)
            message.destroy()
            message.error('Erro ao gerar Grid!')
            tryError(error)
          }
        }
        webWorkerBook.postMessage({ command: 'message-book', dados: dataUrls })
      }

      fetchData()
    }
  }, [dataElementos])

  // console.log('DATAkricagem', dataKricagem)
  // console.log('DataElementos', dataElementos)

  // useEffect(() => {
  //   if (dataKricagem.length > 0) {
  //     isLoading?.(true)
  //   }
  // }, [dataKricagem])

  useEffect(() => {
    isLoading?.(false)
    listConfigMapaFertilidade()
  }, [])

  // useEffect(() => {
  //   if (mapL.current.length > 0) {
  //     mapL.current.forEach((map) => {
  //       map.setZoom(rangeZoom)
  //     })
  //   }
  // }, [rangeZoom])

  let pagina = 5
  let paginaMapa = 5

  // console.log("dataKricagem: ", dataKricagem);

  function novaListadeFertilidades(lista_fertility: ItensMapaFertilidadeTypes[]) {
    let dados_receber = lista_fertility;
    // console.log("lista_fertility: ", lista_fertility);
    for (let i = 0; i < dados_receber?.length ?? 0; i++) {
      const item_elemento = dados_receber?.[i];
      item_elemento.elemento_descricao = item_elemento.cod_elemento==30 
        ? (`Calcário | ${item_elemento.profundidade}`).slice(0, 16)
        : `${item_elemento.elemento_descricao}`;
  }
  // console.log("dados_receber: ", dados_receber);
  return dados_receber;
}
// console.log("ids: ", dataConfigMapaFertilidade?.mapa_fertilidade?.elementos);
/**separa o calcário baseado na `profundidade` ao invés do cod_elemento 
 * 
 * pega o nome do elemento Calcário e concatena a profundidade; exemplo: `Calcário` + `00-20`
 * 
 * depois compara com o `elemento_descricao` que já foi concatenada anteriormente na função `novaListadeFertilidades`
*/
function separarCalcarioPorProfundidade(elemento_descricao: string) {
  
  switch (elemento_descricao) {
    case "Calcário | 00-20":
      return dataConfigMapaFertilidade?.mapa_fertilidade?.elementos.find(
        (rec) => String(rec.title+' | 00-20') === elemento_descricao
      )?.children?.[0]
    case "Calcário 00-20":
      return dataConfigMapaFertilidade?.mapa_fertilidade?.elementos.find(
        (rec) => String(rec.title+' 00-20') === elemento_descricao
      )?.children?.[0]

    case "Calcário | 00-30":
      return dataConfigMapaFertilidade?.mapa_fertilidade?.elementos.find(
        (rec) => String(rec.title+' | 00-30') === elemento_descricao
      )?.children?.[0]
    case "Calcário 00-30":
      return dataConfigMapaFertilidade?.mapa_fertilidade?.elementos.find(
        (rec) => String(rec.title+' 00-30') === elemento_descricao
      )?.children?.[0]

    case "Calcário | 00-40":
      return dataConfigMapaFertilidade?.mapa_fertilidade?.elementos.find(
        (rec) => String(rec.title+' | 00-40') === elemento_descricao
      )?.children?.[0]
    case "Calcário 00-40":
      return dataConfigMapaFertilidade?.mapa_fertilidade?.elementos.find(
        (rec) => String(rec.title+' 00-40') === elemento_descricao
      )?.children?.[0]

  
    default:
        return dataConfigMapaFertilidade?.mapa_fertilidade?.elementos.find(
          (rec) => Number(rec.key) === 3000
        )?.children?.[0]
  }
  
}

useEffect(() => {
  if (!openBook) {
    setDataKrikagem([]);
  }
}, [openBook])

/**add `|` para separar o nome da profundidade */
function replaceCalcario(nome_calcario: string) {
  switch (nome_calcario) {
    case 'Calcário 00-20':
      return 'Calcário | 00-20'
    case 'Calcário | 00-20':
      return 'Calcário 00-20'
    case 'Calcário 00-30':
      return 'Calcário | 00-30'
    case 'Calcário 00-40':
      return 'Calcário | 00-40'
  
    default:
      return nome_calcario
  }
}
useEffect(() => {
  filtrarDadosLocal()
}, [])
// console.log("cores_filtradas: ", cores_filtradas);

  function obterElementoDescricao(lista_de_elementos:any, nome_elemento: string) {

    // return lista_de_elementos[nome_elemento]?.[0];
    return lista_de_elementos[replaceCalcario(nome_elemento)]?.[0] ?? lista_de_elementos[nome_elemento]?.[0];
  }

  return (
    <Container>
      {loading ? (
        <div
          style={{
            display: 'flex',
            width: '100%',
            height: '100vh',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Spin size='large' />
        </div>
      ) : (
        <>
          <BackToTopButton idScroll={idScroll} idBack='sumario' />
          <PdfPrint id={idPrint} ref={refPrint}>
            <Capa className='break'  id='topo-documento'>
              <div className='title'>
                <h2>Ronaldo Araújo Marques</h2>
                <span>Engenheiro Agrônomo</span>
              </div>
              <div className='footer'>
                
                <div>
                  <img className='Capa__logo' src={logo_cliente ?? consultoria?.logo_url} alt={!!consultoria?.logo_url ? 'logo-consultoria' : 'consultoria-logo'} />
                </div>
              </div>
            </Capa>

            <Sumario id='sumario' className={(typeKricagem || sempre_quebrar_sumario) ? 'break-manual' : 'break'} $interpretado={typeKricagem} ref={refSumario}>
              <span className='Sumario__referencia'>
              <h2>Sumário</h2>
              <ul key={uuid()} className='ul-principal'>
                {dataKricagem.map((data, index) => {
                  const profundidade =
                    index === dataKricagem.length - 2 ? 'indicadores' :
                    index === dataKricagem.length - 1 ? 'prescricoes' 
                      
                    : typeKricagem ? data.dataProfundidade[0]?.profundidade : // se for interpretado, pegará a profundidade do array
                        (index === dataKricagem.length - 2 ? 'indicadores': data.dataProfundidade[0]?.profundidade) // se for distribuido, verifica a penultima posicção, se não, pegará a profundidade do array
                  const pro = profundidade.replace('-', ' a ')
                  

                  pagina = index === 0 ? pagina + 1 : pagina + 2
                  let pageResumo = 0

                  return (
                    <>
                    {((typeKricagem && profundidade==='prescricoes') || (sempre_quebrar_sumario && profundidade==='prescricoes')) &&(<div className='quebrar-forca' style={{width: '100%', height: 0}} />)}
                    <li className='li-principal'>
                      <div className='div-principal'>
                        <div>
                          <a href={`#${pro}`}>
                            {profundidade === 'indicadores'
                              ? 'Indicadores'
                              : profundidade === 'prescricoes' ? 'Prescrições' : `Pontos coletados ${pro === '00 a 50' ? 'Granulometria' : pro} ${
                                  typeKricagem ? 'interpretado' : 'distribuído'
                                }: `}
                          </a>
                        </div>
                        <div key={uuid()}>{pagina}</div>
                      </div>
                      <ul className='ul-secundaria'>
                        {(data.krigagem ?? []).map((krig, i) => {
                          
                          const fertility = profundidade==='prescricoes' ? AgruparElementosPrecricao(dataFertilidade[profundidade]) : dataFertilidade[profundidade];
                          const elementData = groupBy(fertility, 'elemento_descricao')

                          // const dataElemento = elementData[replaceCalcario(krig?.descriptionElemento)]?.[0];
                          const dataElemento = obterElementoDescricao(elementData, krig?.descriptionElemento);

                        

                          const elemento = dataElemento
                          
                          const configElemento = Number(elemento?.cod_elemento) !== 30 
                          ?
                            dataConfigMapaFertilidade?.mapa_fertilidade?.elementos?.find(
                              (rec) => Number(rec.key) === Number(elemento?.cod_elemento)
                            )?.children?.[typeKricagem ? 1 : 0]
                          : 
                            separarCalcarioPorProfundidade(String(elemento?.elemento_descricao))
                            
                          const nameProfu = profundidade;

                          const existePro = configElemento?.params?.profundidades
                          
                          let filterPro = []
                          if (existePro) {
                            filterPro = Object.keys(configElemento?.params?.profundidades)?.filter(
                              (key) => configElemento?.params?.profundidades[key]?.exibe !== '0'
                            )
                          } else {
                            filterPro = []
                          }

                          const proExiste = filterPro?.filter((rec) => rec === nameProfu)
                          let resumoPage = (page) => {
                            if (i === data.krigagem.length - 1 && profundidade !== 'indicadores' && profundidade !== 'prescricoes') {
                              return (
                                <li className='li-secundaria'>
                                  <div className='div-secundaria'>
                                    <div>
                                      <a href={`#resumo${data.dataProfundidade[0]?.profundidade}`}>
                                        Resumo de análises{' '}
                                        {data.dataProfundidade[0]?.profundidade.replace('-', ' a ')}{' '}
                                        {data.dataProfundidade[0]?.profundidade !== 'micro' &&
                                          'cm:'}
                                      </a>
                                    </div>
                                    <div>{page}</div>
                                  </div>
                                </li>
                              )
                            }
                            return null
                          }
                          pagina = pagina + 1

                          if (i === data.krigagem.length - 1) {
                            // pagina += 1
                            pageResumo = pagina + 1
                          }
                          if (proExiste?.length <= 0) {
                            pagina -= 1
                            pageResumo = pageResumo - 1
                            return resumoPage(pageResumo)
                          } else {
                            return (
                              <>
                              {/* {(i==4 && profundidade==='prescricoes') && <><br/><br/><br/><br/><br/><br/></>} */}
                              {/* {(i==4 && profundidade==='prescricoes' && typeKricagem) && <div className='force_margen_sumario' style={{width: '100%', height: 60 }} />} */}
                                <li className='li-secundaria' id={`item_elemento_${i}`}>
                                  <div className='div-secundaria'>
                                    <div>
                                      <a href={`#${pro}${elemento?.elemento_descricao}`}>
                                        {elemento?.elemento_descricao}:
                                      </a>{' '}
                                    </div>
                                    <div>{pagina}</div>
                                  </div>
                                </li>
                                {resumoPage(pageResumo)}
                              </>
                            )
                          }
                        })}
                      </ul>
                    </li>
                    </>
                  )
                })}
              </ul>
              </span>
              {/* <div className='final_da_lista' ref={refListaSumario}/> */}
            </Sumario>

            <Warning className='break '>
              <div
                className='msg'
                dangerouslySetInnerHTML={{
                  __html: decodeHtml(dataConfigMapaFertilidade.mapa_fertilidade?.texto_introducao),
                }}
              />

              <div className='logo'>
                <div>
                  <img className='Warning__logo' src={logo_cliente ?? consultoria?.logo_url} alt='logo-consultoria' />
                </div>
              </div>
            </Warning>



            {/* {([]).map((data, index) => { */}
            {dataKricagem.map((data, index) => { 
              // const namePro =
              //   index === dataKricagem.length - 1
              //     ? 'indicadores'
              //     : data.dataProfundidade[0]?.profundidade
              // const pro = namePro.replace('-', ' a ').split(' ')
              
              const namePro =
                index === dataKricagem.length - 2 ? 'indicadores' :
                index === dataKricagem.length - 1 ? 'prescricoes' :
                
                typeKricagem ? data.dataProfundidade[0]?.profundidade : // se for interpretado, pegará a profundidade do array
                  (index === dataKricagem.length - 2 ? 'indicadores': data.dataProfundidade[0]?.profundidade) // se for distribuido, verifica a penultima posicção, se não, pegará a profundidade do array
              const pro = namePro.replace('-', ' a ').split(' ')


              paginaMapa = index === 0 ? paginaMapa + 1 : paginaMapa + 2

              let pageResumo = 0

              const profundidade =
              index === dataKricagem.length - 2 ? 'indicadores' :
              index === dataKricagem.length - 1 ? 'prescricoes' :
              typeKricagem ? data.dataProfundidade[0]?.profundidade :
                    (index === dataKricagem.length - 2 ? 'indicadores': data.dataProfundidade[0]?.profundidade)

              if (profundidade === 'indicadores') {
                pagina -= (typeKricagem ? 1 : 2)
              }
              if (profundidade === 'prescricoes') {
                pagina -= 1
              }

              return (
                <>
                  <SubCapa
                    className='break'
                    hidden={profundidade === '00-50'}
                    profundidade={profundidade}
                    isPrescricoes={profundidade==='prescricoes'}
                    isIndicadores={profundidade==='indicadores'}
                  >
                    <div className='header'>
                      <h1>
                        {pro.map((rec) => {
                          let ele
                          if (rec === 'a') {
                            ele = <span style={{ color: '#00a8b9' }}>{rec}</span>
                          } else {
                            ele = <b style={{ fontSize: '35px' }}>{capitalize(String(rec)?.replace("prescricoes",''))}</b>
                          }
                          return ele
                        })}
                        <span style={{ color: '#00a8b9' }}>
                          {' '}
                          {(profundidade !== 'micro' && profundidade !== 'indicadores' && profundidade !=='prescricoes') && 'cm:'}
                        </span>
                      </h1>
                    </div>
                    <div className='footer'>
                      <div>
                        <img className='SubCapa__logo' src={logo_cliente ?? consultoria.logo_url} alt='logo-consultoria' />
                      </div>
                    </div>
                  </SubCapa>

                  <SubCapaWhite className='break' hidden={profundidade !== '00-50'}>
                    <div className='header'>
                      <h1>
                        {pro.map((rec) => {
                          let ele
                          if (rec === 'a') {
                            ele = <span style={{ color: '#00a8b9' }}>{rec}</span>
                          } else {
                            ele = <b style={{ fontSize: '35px' }}>{capitalize(rec)}</b>
                          }
                          return ele
                        })}
                        <span style={{ color: '#00a8b9' }}>
                          {' '}
                          {(profundidade !== 'micro' && profundidade !== 'indicadores' && profundidade !=='prescricoes') && 'cm:'}
                        </span>
                      </h1>
                    </div>
                    <div className='title'>
                      <div>Granulometria</div>
                    </div>
                    <div className='footer'>
                      <div>
                        <img src={logo_cliente ?? consultoria.logo_url} alt='logo-consultoria' />
                      </div>
                    </div>
                  </SubCapaWhite>

                  <ContentPontos className='break' hidden={profundidade === 'indicadores' || profundidade ==='prescricoes'}>
                    <Card size='small' className='header'>
                      <h1 id={pro.join(' ')}>PONTOS COLETADOS </h1>
                      <h1 key={profundidade}>{capitalize(profundidade)}</h1>
                    </Card>
                    <MapLeaflet
                      exibeTerreno={exibeTerreno}
                      sizeMarcaDagua={3}
                      className='map-style'
                      whenCreated={(map) => {
                        map.fitBounds(defaultBounds)
                        onRangeZoom?.(map.getZoom())
                      }}
                      zoomAnimation={true}
                      scrollWheelZoom={false}
                      zoomControl={false}
                      dragging={false}
                      style={{
                        width: '95%',
                        height: '60%',
                        borderRadius: '10px',
                      }}
                    >
                      {data.circle.map((ltdLng) => {
                        const ponto = data.dataProfundidade.find(
                          (rec) =>
                            Number(rec.latitude) === ltdLng[0] &&
                            Number(rec.longitude) === ltdLng[1]
                        ).ponto
                        return <Marker position={ltdLng} icon={iconDiv(ponto)} />
                      })}
                      <Polygon
                        positions={polygon}
                        pathOptions={{
                          opacity: 1,
                          color: 'cyan',
                          fillColor: 'cyan',
                          fillOpacity: 0.3,
                        }}
                      />
                    </MapLeaflet>

                    <Descriptions
                      style={{ marginBottom: 70, width: '100%', padding: '15px' }}
                      labelStyle={{
                        fontSize: 12,
                        fontWeight: 'bold',
                        backgroundColor: '#f1f1f1',
                      }}
                      column={1}
                      size='small'
                      bordered
                      layout='horizontal'
                    >
                      <Descriptions.Item label='Produtor'>{nameCliente}</Descriptions.Item>
                      <Descriptions.Item label='Fazenda'>{propriedade?.nome}</Descriptions.Item>
                      <Descriptions.Item label='Campo'>
                        {talhaoNome} - {areaTalhao}ha
                      </Descriptions.Item>
                      <Descriptions.Item label='Total de pontos coletados:'>
                        {data.circle.length}
                      </Descriptions.Item>
                    </Descriptions>
                    <RodapeTtivvos logo={false} />
                    <Page>{paginaMapa}</Page>
                  </ContentPontos>
                  {((data.krigagem ?? [])).map((krig, i) => {
                    const bounds = L.polygon(polygon, {})
                    // const fertility = dataFertilidade[profundidade]
                    const fertility = dataFertilidade[profundidade];
                    let fertilidade_concatenada = novaListadeFertilidades(fertility)
                    // let fetilidade_concatenada = typeKricagem ? fertility : novaListadeFertilidades(fertility)
                    const elementData = groupBy(fertilidade_concatenada, 'elemento_descricao')
                    // console.log("elementData: ", elementData);
                    const elemento = obterElementoDescricao(elementData, krig?.descriptionElemento);
                    // const elemento = elementData[replaceCalcario(krig?.descriptionElemento)]?.[0]
                    const codElemento = elemento?.cod_elemento
                    const reverse =
                      codElemento === 7  || // Alumínio
                      codElemento === 18 || // Saturação por Alumínio (m%)
                      codElemento === 28 || // Resposta à adubação potássica
                      codElemento === 30 || //  Calcario
                      codElemento === 31 || // Gesso 
                      codElemento === 32 || // KCL antes da correção com calcário
                      codElemento === 49 || // KCL após a calagem
                      codElemento === 41 || // Adubação fosfatada soja antes da calagem
                      codElemento === 42 || // Adubação fosfatada milho antes da calagem
                      codElemento === 46 || // Adubação fosfatada sistema antes da calagem
                      codElemento === 43 || // Adubação fosfatada soja após a calagem
                      codElemento === 44 || // Adubação fosfatada milho após a calagem
                      codElemento === 45 || // Adubação fosfatada sistema após a calagem
                      codElemento === 50   
                    const unidade = elementosData.find((rec) => rec.cod === codElemento)?.unidade
                    paginaMapa = paginaMapa + 1
                    if (i === data.krigagem.length - 1) {
                      // paginaMapa += 1
                      pageResumo = paginaMapa + 1
                    }
                    
                    const configElemento = Number(elemento?.cod_elemento) !== 30 
                          ?
                            dataConfigMapaFertilidade?.mapa_fertilidade?.elementos?.find(
                              (rec) => Number(rec.key) === Number(elemento?.cod_elemento)
                            )?.children?.[typeKricagem ? 1 : 0]
                          : 
                            separarCalcarioPorProfundidade(String(elemento?.elemento_descricao))

                    const nameProfu = profundidade

                    const existePro = configElemento?.params?.profundidades
                    let filterPro = []
                    if (existePro) {
                      filterPro = Object.keys(configElemento?.params?.profundidades)?.filter(
                        (key) => configElemento?.params?.profundidades[key]?.exibe !== '0'
                      )
                    } else {
                      filterPro = []
                    }

                    const proExiste = filterPro?.filter((rec) => rec === nameProfu)

                    if (proExiste?.length <= 0) {
                      pageResumo = pageResumo - 1
                      paginaMapa -= 1
                      return null
                    } else {
                      return (
                        <Content className='break'>
                          <Card
                            id={pro.join(' ') + elemento?.elemento_descricao}
                            size='small'
                            className='header'
                          >
                            <h2>{krig.descriptionElemento}</h2>
                            <h2 style={{marginTop: -12}}>
                              {String(profundidade)?.replace("prescricoes",'prescrições')}
                              {profundidade !== 'micro' &&
                                profundidade !== 'indicadores' &&
                                profundidade !== 'prescricoes' &&
                                ' cm'}{((profundidade==='prescricoes')?'':',')}{' '}
                              {profundidade!=='prescricoes' &&(
                                <span>{typeKricagem ? 'interpretado' : 'distribuído'} </span>
                              )}
                              
                            </h2>
                          </Card>
                          <MapLeaflet
                            id={`map_krig${i}`}
                            exibeTerreno={exibeTerreno}
                            sizeMarcaDagua={3}
                            scrollWheelZoom={false}
                            className='map-style map-dimension'
                            zoomAnimation
                            zoomSnap={0}
                            zoomDelta={0.25}
                            zoomControl={false}
                            dragging={false}
                            whenCreated={(map) => {
                              map.fitBounds(defaultBounds, { padding: [45, 45] })
                              mapL.current = [...mapL.current, map]
                            }}
                          >
                            {krig.colors.length > 1 && (
                              <ImageOverlay
                                key={krig.url}
                                url={krig.url}
                                bounds={bounds.getBounds()}
                              />
                            )}
                            <Polygon
                              positions={polygon}
                              pathOptions={{
                                opacity: 1,
                                color: 'cyan',
                                fillColor: krig.colors.length === 1 && krig.colors[0],
                                fillOpacity: krig.colors.length === 1 ? 1 : 0,
                                weight: 5,
                              }}
                            />
                          </MapLeaflet>
                          
                          <TabelaFertilidade 
                            nome_cliente={nameCliente!=='' ? (nameCliente ?? nome_cliente) : nome_cliente}
                            nome_propriedade={propriedade?.nome}
                            logo_url={logo_cliente ?? consultoria?.logo_url}
                            nome_calcario_propriedade={nome_calcario_propriedade}

                            nome_talhao={talhaoNome}
                            data_coleta={!!dataColeta ? dayjs(dataColeta).format('DD/MM/YYYY') ?? 'Não informado' : 'Não informado'}
                            profundidade={`${profundidade}                                       ${
                              profundidade !== 'micro' && profundidade !== 'indicadores' && profundidade !=='prescricoes'
                                ? 'cm'
                                : ''
                            }`}
                            elemento_analisado={replaceCalcario(krig?.descriptionElemento)}

                            unidade={unidade}
                            nota_minima={obterElementoDescricao(elementData, krig?.descriptionElemento)?.minimo}
                            nota_media={obterElementoDescricao(elementData, krig?.descriptionElemento)?.media}
                            nota_maxima={obterElementoDescricao(elementData, krig?.descriptionElemento)?.maximo}
                            cor_invertida={reverse}
                            isPrescricao={profundidade==='prescricoes'}
                            isIndicadores={profundidade==='indicadores'}
                            colors={krig?.colors}
                            interpretado_minimo={krig?.valor_interpretado?.minimo}
                            interpretado_media={krig?.valor_interpretado?.media}
                            interpretado_maximo={krig?.valor_interpretado?.maximo}
                            cod_elemento={elemento?.cod_elemento}
                            isInterpretado={typeKricagem}
                            areaTalhao={Number(areaTalhao)}
                          /> 

                          <div style={{ width: '100%', marginBottom: 100 }}>
                            <Card
                              style={{}}
                              bodyStyle={{ textAlign: 'left', height: 70, fontSize: 12 }}
                              size='small'
                            >
                              <b>Obs.: </b>{' '}
                              {configElemento?.params?.profundidades?.[proExiste[0]].obs}
                            </Card>
                          </div>
                          <RodapeTtivvos logo={false} />

                          <Page>{paginaMapa}</Page>
                        </Content>
                      )
                    }
                  })}

                  {(profundidade !== 'indicadores' && profundidade !=='prescricoes' ) && (
                    <ResumoNutrientes className='break'>
                      <h2 id={`resumo${data.dataProfundidade[0]?.profundidade}`}>
                        Resumo de análises{' '}
                        {data.dataProfundidade[0]?.profundidade.replace('-', ' a ')} {(data.dataProfundidade[0]?.profundidade)==='micro' ?'00 a 20' : 'cm'}
                      </h2>
                      <div className='div-table'>
                        <table>
                          <thead>
                            <tr>
                              <th>Elemento</th>
                              <th>Mínimo</th>
                              <th>Média</th>
                              <th>Máximo</th>
                              {/* <th>Unidade</th> */}
                            </tr>
                          </thead>
                          <tbody>
                            {data.krigagem.map((rec, index) => {
                              if (index === 0) {
                                pagina = pagina + 1
                              }

                              const fertility =
                                dataFertilidade[data.dataProfundidade[0]?.profundidade]
                              const elementData = groupBy(fertility, 'elemento_descricao')
                              const elemento = elementData[rec?.descriptionElemento]?.[0]
                              const codElemento = elemento?.cod_elemento
                              const unidade = elementosData.find(
                                (rec) => rec.cod === codElemento
                              )?.unidade

                              const reverse =
                                codElemento === 7 || codElemento === 18 || codElemento === 28 || codElemento === 30

                              pagina = pagina + 1

                              const configElement =
                                dataConfigMapaFertilidade.mapa_fertilidade?.elementos.find(
                                  (rec) => Number(rec.key) === Number(elemento?.cod_elemento)
                                )
                              const exibe =
                                configElement?.children[typeKricagem ? 1 : 0].params.profundidades[
                                  data.dataProfundidade[0]?.profundidade
                                ].exibe === '1'
                              if (!exibe) {
                                return null
                              }
                              return (
                                <TrReverse reverse={reverse}>
                                  <th>
                                    {rec.descriptionElemento}
                                    <small>{unidade !== null && unidade}</small>
                                  </th>
                                  <td>
                                    <div>
                                      {elementData[rec?.descriptionElemento]?.[0]?.minimo}{' '}
                                      <div
                                        style={{ backgroundColor: rec.colors[0] }}
                                        hidden={!typeKricagem}
                                        className='circle'
                                      />
                                    </div>
                                  </td>
                                  <td>
                                    <div>
                                      {elementData[rec?.descriptionElemento]?.[0]?.media}{' '}
                                      <div
                                        style={{
                                          backgroundColor: rec.colors[middleIndex(rec.colors)],
                                        }}
                                        hidden={!typeKricagem}
                                        className='circle'
                                      />
                                    </div>
                                  </td>
                                  <td>
                                    <div>
                                      {elementData[rec?.descriptionElemento]?.[0]?.maximo}{' '}
                                      <div
                                        style={{
                                          backgroundColor: rec.colors[rec.colors.length - 1],
                                        }}
                                        hidden={!typeKricagem}
                                        className='circle'
                                      />
                                    </div>
                                  </td>
                                  {/* <td>{unidade === null ? '-' : unidade}</td> */}
                                </TrReverse>
                              )
                            })}
                          </tbody>
                        </table>
                      </div>
                      <Page>{pageResumo}</Page>
                    </ResumoNutrientes>
                  )}
                </>
              )
            })}
          </PdfPrint>
        </>
      )}
    </Container>
  )
}

export default DrawerPrintMapaFertilidade